import number from '~/assets/icons/plateNumber.svg';
import logo from '../../assets/images/logo.svg';
import { StyledContainer, StyledHeading } from './Head.styled';

const Head: React.FC = () => {
	return (
		<StyledContainer>
			<StyledHeading>
				<img src={number} />
				<img src={logo} />
			</StyledHeading>
		</StyledContainer>
	);
};

export { Head };
